import React from "react";
import "./AppDev.css";
import appImage from "./app-image.jpg"; // Ensure the image path is correct
import { useLanguage } from "../../Context/LanguageContext"; // Import context

const AppDev = () => {
    const { t } = useLanguage(); // Access translations

    return (
        <section className="appdev">
            <div className="content">
                <div className="left">
                    <h3>{t.sub_app_dev}</h3> {/* Service title from translations */}
                    <p>{t.appdev_paragraph1}</p> {/* First paragraph */}
                    <p>{t.appdev_paragraph2}</p> {/* Second paragraph */}
                </div>
                <div className="right">
                    <img src={appImage} alt={t.sub_app_dev} /> {/* Alt text translated */}
                </div>
            </div>
        </section>
    );
};

export default AppDev;
